module.exports = __webpack_public_path__ + "static/assets/0bc0d8117635d3a49cdda39c562ca88f.png";